import * as React from "react";
const Draw = props => <symbol viewBox="0 0 24 24" {...props}>
    <g>
      <path d="M13.59 14H11a.75.75 0 01-.75-.75v-2.59c-.001-.46.18-.901.502-1.228L16.686 3.4a1.738 1.738 0 011.239-.523h.009a1.74 1.74 0 011.237.512l1.69 1.69a1.749 1.749 0 01-.011 2.486l-6.032 5.933a1.748 1.748 0 01-1.227.502zm-1.84-1.5h1.84a.254.254 0 00.177-.072l6.03-5.933a.248.248 0 00.003-.355l-1.69-1.69a.252.252 0 00-.177-.073.3.3 0 00-.177.074l-5.934 6.033a.249.249 0 00-.072.175z" />
      <path d="M19 22h-4a.75.75 0 110-1.5h4a1.25 1.25 0 000-2.5H5a2.75 2.75 0 110-5.5h2A.75.75 0 117 14H5a1.25 1.25 0 000 2.5h14a2.75 2.75 0 110 5.5z" />
    </g>
  </symbol>;
export default Draw;